import { TeButton, TeContainer, TeText } from '@topcon/tuicl-react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useFilters } from './hooks';

interface Props {
  filterData: ReturnType<typeof useFilters>;
  title: string;
  description: string;
  children: ReactNode;
}

function FilterContainer({ filterData, title, description, children }: Props) {
  const { t } = useTranslation('users');
  const { handleClear, canApply, hasPendingChanges, filters, filtersCopy, handleApply } =
    filterData;
  return (
    <>
      <TeContainer shadow="bottom" gap="xs" column fill>
        <TeText size={16} weight={700}>
          {title}
        </TeText>
        <TeText size={12} weight={500}>
          {description}
        </TeText>
      </TeContainer>

      {children}

      <TeContainer shadow="top" gap="xs" padding="xs" fill>
        <TeButton
          text={t('clear')}
          variant="secondary"
          disabled={(!hasPendingChanges && filters.length === 0) || filtersCopy.length === 0}
          teclick={handleClear}
          size="s"
          grow
        />
        <TeButton
          text={t('apply')}
          variant="primary"
          teclick={handleApply}
          disabled={!canApply}
          size="s"
          grow
        />
      </TeContainer>
    </>
  );
}

export default FilterContainer;
